import React from "react";
import { Row, Col, Tooltip } from "antd";
import { Info } from "@material-ui/icons";
import { UPLOAD_TYPE } from "../uploadTypeEnum";

const exampleCSV = `date_from,date_to,source_site,target_site
03/01/26,03/15/26,makro_loei,makro_chumphon
03/01/26,03/31/26,source_table_name,dest_table_name`;

const downloadExampleCSV = () => {
  const blob = new Blob([exampleCSV], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "example_irradiance_range.csv";
  a.click();
  URL.revokeObjectURL(url);
};

export const updateIrradianceCSVUploadConfig = {
  modal: {
    title: () => (
      <>
        Irradiance Range CSV Format{"  "}
        <Tooltip
          overlayClassName="custom-tooltip-wide"
          title={
            <>
              <p className="custom-small-font" style={{ textIndent: "2em" }}>
                The CSV file must contain the following columns:
              </p>
              <ul className="custom-small-font">
                <li><b>date_from</b> — Start date (MM/DD/YY)</li>
                <li><b>date_to</b> — End date (MM/DD/YY)</li>
                <li><b>source_site</b> — Source site table_name (copy irradiance from)</li>
                <li><b>target_site</b> — Target site table_name (copy irradiance to)</li>
              </ul>
            </>
          }
          placement="bottom"
        >
          <Info />
        </Tooltip>
      </>
    ),
    content: () => (
      <>
        <Row>
          <Col span={24}>
            <p className="custom-medium-font" style={{ textIndent: "2em" }}>
              Upload a CSV to copy irradiance values from a <b>source_site</b> to
              a <b>target_site</b> for a date range. Both sites must exist in the
              database.
            </p>
          </Col>
        </Row>
        <Row style={{ marginTop: "15px" }}>
          <Col span={24}>
            <p className="custom-medium-font"><b>Example CSV:</b></p>
            <pre style={{ background: "#f5f5f5", padding: "10px", fontSize: "12px", overflowX: "auto" }}>
{exampleCSV}
            </pre>
          </Col>
        </Row>
        <Row style={{ marginTop: "10px" }}>
          <Col span={24}>
            <button className="btn btn-default btn-sm" onClick={downloadExampleCSV}>
              Download Example CSV
            </button>
          </Col>
        </Row>
      </>
    ),
  },
  form: {
    title: UPLOAD_TYPE.IRRADIANCE,
    description: "Upload a CSV that copies irradiance from a source site to a destination site and recalculates PR.",
    upload: {
      uploadUrl: "/daily/upload_update_irradiance",
      maxCount: 1,
      accept: ".csv",
      isInvalid: (file) => {
        const fileName = file.name.toLowerCase();
        if (!fileName.endsWith(".csv")) return "You can only upload CSV files!";
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) return "File must be smaller than 5MB!";
      },
    },
  },
};
